import React, { useEffect, useRef, useState } from 'react';
import Pincode from '../../models/Pincode.js';
import Multiselect from 'multiselect-react-dropdown';
import { getApi } from '../../api/endpoints.js';

const FormPartial = (props) => {
  const { pincodeModel, setPincodeModel } = props;
  const pincodeModelObj = new Pincode(pincodeModel);
  const [statesApi] = getApi('states');
  const [districtsApi] = getApi('districts');
  const [branchesApi] = getApi('branches');
  const [clustersApi] = getApi('clusters');
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [branches, setBranches] = useState([]);
  const [clusters, setClusters] = useState([]);
  const cluster_ref = useRef();

  useEffect(() => {
    fetchOptions(statesApi, "states", {}, setStates);
    fetchOptions(districtsApi, "districts", {}, setDistricts);
    fetchOptions(branchesApi, "branches", {}, setBranches);
  }, [])

  const fetchOptions = async (api, key, params = {}, setFunction) => {
    try {
      const response = await api(params).unwrap();
      setFunction(response.data[key]);
    } catch (error) {
    }
  }

  const onStateSelect = (key, selectedItem) => {
    pincodeModelObj[key] = selectedItem;
    validateValue(key);
    setPincodeModel(pincodeModelObj.toStateJson());
  }

  const onDistrictSelect = (key, selectedItem) => {
    pincodeModelObj[key] = selectedItem;
    validateValue(key);
    setPincodeModel(pincodeModelObj.toStateJson());
  }

  const onBranchSelect = (key, selectedItem) => {
    pincodeModelObj['cluster'] = {};
    cluster_ref.current.resetSelectedValues();
    pincodeModelObj[key] = selectedItem;
    validateValue(key);
    setPincodeModel(pincodeModelObj.toStateJson());
    fetchOptions(clustersApi, "clusters", { filters: { branch_ids: selectedItem.id } }, setClusters);
  }

  const onClusterSelect = (key, selectedItem) => {
    pincodeModelObj[key] = selectedItem;
    validateValue(key);
    setPincodeModel(pincodeModelObj.toStateJson());
  }

  const validateValue = (field) => {
    pincodeModelObj.validate(field);
  }

  const changeValue = (field, value) => {
    if(field === 'code'){
      if((value).toString().length > 6){
        return false;
      }
    }
    pincodeModelObj[field] = value;
    validateValue(field);
    setPincodeModel(pincodeModelObj.toStateJson());
  }

  return <React.Fragment>
    <div className="row">
      <div className="col-md-4 my-2">
        <label htmlFor="area" className="form-label mb-1">Area</label>
        <input
          id="area"
          value={pincodeModelObj.area}
          onChange={(e) => changeValue('area', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          aria-describedby="area_help"
          placeholder='Enter Area Name'
        />
        <div id="area_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.area}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="city" className="form-label mb-1">City</label>
        <input
          id="city"
          value={pincodeModelObj.city}
          onChange={(e) => changeValue('city', e.target.value)}
          type="text"
          className="form-control form-control-sm font-size-12"
          aria-describedby="city_help"
          placeholder='Enter City Name'
        />
        <div id="city_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.city}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="code" className="form-label mb-1">PIN Code</label>
        <input
          id="code"
          value={pincodeModelObj.code}
          onChange={(e) => changeValue('code', e.target.value)}
          type="number"
          className="form-control form-control-sm font-size-12"
          aria-describedby="code_help"
          placeholder='Enter PIN Code'
          maxLength={6}
        />
        <div id="code_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.code}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="state" className="form-label mb-1">State</label>
        <Multiselect
          id='state'
          selectedValues={[pincodeModelObj.state]}
          options={states}
          onSelect={(selectedList, selectedItem) => onStateSelect("state", selectedItem)}
          placeholder='Select State from options'
          singleSelect={true}
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
        />
        <div id="state_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.state}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="dist" className="form-label mb-1">District</label>
        <Multiselect
          id='dist'
          selectedValues={[pincodeModelObj.dist]}
          options={districts}
          onSelect={(selectedList, selectedItem) => onDistrictSelect("dist", selectedItem)}
          placeholder='Select district from options'
          singleSelect={true}
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
        />
        <div id="dist_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.dist}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="branch" className="form-label mb-1">Circle</label>
        <Multiselect
          id='branch'
          selectedValues={[pincodeModelObj.branch]}
          options={branches}
          onSelect={(selectedList, selectedItem) => onBranchSelect("branch", selectedItem)}
          placeholder='Select Circle from options'
          singleSelect={true}
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
        />
        <div id="branch_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.branch}
        </div>
      </div>
      <div className="col-md-4 my-2">
        <label htmlFor="cluster" className="form-label mb-1">Cluster</label>
        <Multiselect
          id='cluster'
          selectedValues={[pincodeModelObj.cluster]}
          options={clusters}
          onSelect={(selectedList, selectedItem) => onClusterSelect("cluster", selectedItem)}
          placeholder='Select cluster from options'
          singleSelect={true}
          displayValue={'name'}
          showArrow={true}
          customArrow={true}
          avoidHighlightFirstOption={true}
          ref={cluster_ref}
        />
        <div id="cluster_help" className="form-text text-danger mt-0">
          {pincodeModelObj.errors.cluster}
        </div>
      </div>
    </div>
  </ React.Fragment>
};

export default FormPartial;
